import type { HTMLAttributes } from "react";
import React from "react";
import type { ValidationError } from "@tanstack/react-form";

import { Errors } from "@/components/form/field-errors";
import { cn } from "@/lib/utils";

export interface LabeledFieldProps extends HTMLAttributes<HTMLDivElement> {
  label?: React.ReactNode;
  fieldName?: string;
  children: React.ReactNode;
  infos?: string;
  required?: boolean;
  errors?: Array<ValidationError>;
  gridRow?: boolean;
  fullWidth?: boolean;
}

const LabeledField = ({
  label,
  fieldName,
  children,
  infos,
  required,
  errors,
  className,
  gridRow,
  fullWidth = true,
  ...props
}: LabeledFieldProps) => {
  return (
    <div
      className={cn(
        "flex flex-col items-start space-y-2",
        { "col-span-full": gridRow },
        fullWidth ? "w-full" : "",
        className
      )}
      {...props}
    >
      {label && (
        <label
          className="text-sm font-medium text-muted-foreground"
          htmlFor={fieldName}
        >
          {label}
          <span className="print:hidden">{required && "*"}</span>
        </label>
      )}
      {children}
      <Errors>{errors}</Errors>
      {infos && <p className="text-xs text-muted-foreground">{infos}</p>}
    </div>
  );
};

export default LabeledField;
